export const towerItemsData = [
  {
    id: 1,
    name: "level1",
    data: [
      {
        id: 1,
        name: "banana",
        header: "Banana",
        imageLink: "banana",
        flag: "healthy",
      },
      {
        id: 2,
        name: "boiled-egg",
        header: "Boiled Egg",
        imageLink: "boiledEgg",
        flag: "healthy",
      },
      {
        id: 3,
        name: "oatmeal",
        header: "Oatmeal",
        imageLink: "oatmeal",
        flag: "healthy",
      },
      {
        id: 4,
        name: "water",
        header: "Water",
        imageLink: "water",
        flag: "healthy",
      },
      {
        id: 5,
        name: "brown-rice",
        header: "Brown Rice",
        imageLink: "brownRice",
        flag: "healthy",
      },
      {
        id: 6,
        name: "blueberries",
        header: "Blueberries",
        imageLink: "blueberries",
        flag: "healthy",
      },
      {
        id: 7,
        name: "spinach",
        header: "Spinach",
        imageLink: "spinach",
        flag: "healthy",
      },
      {
        id: 8,
        name: "carrot",
        header: "Carrot",
        imageLink: "carrot",
        flag: "healthy",
      },
      {
        id: 9,
        name: "tomato",
        header: "Tomato",
        imageLink: "tomato",
        flag: "healthy",
      },
      {
        id: 10,
        name: "bell-pepper",
        header: "Bell Pepper",
        imageLink: "bellPepper",
        flag: "healthy",
      },
      {
        id: 11,
        name: "soda",
        header: "Soda",
        imageLink: "soda",
        flag: "unhealthy",
      },
      {
        id: 12,
        name: "donuts",
        header: "Donuts",
        imageLink: "donuts",
        flag: "unhealthy",
      },
      {
        id: 13,
        name: "chips",
        header: "Chips",
        imageLink: "chips",
        flag: "unhealthy",
      },
      {
        id: 14,
        name: "cake-with-frosting",
        header: "Cake with Frosting",
        imageLink: "cakeWithFrosting",
        flag: "unhealthy",
      },
      {
        id: 15,
        name: "icecream-sundae",
        header: "Icecream Sundae",
        imageLink: "icecreamSundae",
        flag: "unhealthy",
      },
    ],
  },
  {
    id: 2,
    name: "level2",
    data: [
      {
        id: 1,
        name: "plain-popcorn",
        header: "Plain Popcorn",
        imageLink: "plainPopcorn",
        flag: "healthy",
      },
      {
        id: 2,
        name: "fresh-fruit-salad",
        header: "Fresh Fruit Salad",
        imageLink: "freshFruitSalad",
        flag: "healthy",
      },
      {
        id: 3,
        name: "plain-greek-yogurt",
        header: "Plain Greek Yogurt",
        imageLink: "plainGreekYogurt",
        flag: "healthy",
      },
      {
        id: 4,
        name: "unsalted-nuts",
        header: "Unsalted Nuts",
        imageLink: "unsaltedNuts",
        flag: "healthy",
      },
      {
        id: 5,
        name: "whole-grain-toast",
        header: "Whole Grain Toast",
        imageLink: "wholeGrainToast",
        flag: "healthy",
      },
      {
        id: 6,
        name: "whole-wheat-pancake-fruit",
        header: "Whole Wheat Pancake with Fruits",
        imageLink: "wholeWheatPancakeFruit",
        flag: "healthy",
      },
      {
        id: 7,
        name: "zucchini-noodles",
        header: "Zucchini Noodles",
        imageLink: "zucchiniNoodles",
        flag: "healthy",
      },
      {
        id: 8,
        name: "roasted-chickpeas",
        header: "Roasted Chickpeas",
        imageLink: "roastedChickpeas",
        flag: "healthy",
      },
      {
        id: 9,
        name: "radishes",
        header: "Radishes",
        imageLink: "radishes",
        flag: "healthy",
      },
      {
        id: 10,
        name: "puffed-brown-rice",
        header: "Puffed Brown Rice",
        imageLink: "puffedBrownRice",
        flag: "healthy",
      },
      {
        id: 11,
        name: "butter-popcorn",
        header: "Butter Popcorn",
        imageLink: "butterPopcorn",
        flag: "unhealthy",
      },
      {
        id: 12,
        name: "canned-fruit-syrup",
        header: "Canned Fruit in Syrup",
        imageLink: "cannedFruitSyrup",
        flag: "unhealthy",
      },
      {
        id: 13,
        name: "flavored-sweetened-yogurt",
        header: "Flavored Sweetened Yogurt",
        imageLink: "flavoredSweetenedYogurt",
        flag: "unhealthy",
      },
      {
        id: 14,
        name: "honey-roasted-nuts",
        header: "Honey Roasted Nuts",
        imageLink: "honeyRoastedNuts",
        flag: "unhealthy",
      },
      {
        id: 15,
        name: "white-bread-toast",
        header: "White Bread Toast",
        imageLink: "whiteBreadToast",
        flag: "unhealthy",
      },
    ],
  },
  {
    id: 3,
    name: "level3",
    data: [
      {
        id: 1,
        name: "dark-chocolate-70",
        header: "Dark Chocolate (70% Cocoa)",
        imageLink: "darkChocolate70",
        flag: "healthy",
      },
      {
        id: 2,
        name: "oven-baked-fish",
        header: "Oven Baked Fish",
        imageLink: "ovenBakedFish",
        flag: "healthy",
      },
      {
        id: 3,
        name: "apple-nut-butter",
        header: "Apple Slices with Nut Butter",
        imageLink: "appleNutButter",
        flag: "healthy",
      },
      {
        id: 4,
        name: "baked-zucchini-fries",
        header: "Baked Zucchini Fries",
        imageLink: "bakedZucchiniFries",
        flag: "healthy",
      },
      {
        id: 5,
        name: "avocado",
        header: "Avocado",
        imageLink: "avocado",
        flag: "healthy",
      },
      {
        id: 6,
        name: "olives",
        header: "Olives",
        imageLink: "olives",
        flag: "healthy",
      },
      {
        id: 7,
        name: "tofu",
        header: "Tofu",
        imageLink: "tofu",
        flag: "healthy",
      },
      {
        id: 8,
        name: "steel-cut-oatmeal-berries",
        header: "Steel Cut Oatmeal with Berries",
        imageLink: "steelCutOatmealBerries",
        flag: "healthy",
      },
      {
        id: 9,
        name: "edamame",
        header: "Edamame",
        imageLink: "edamame",
        flag: "healthy",
      },
      {
        id: 10,
        name: "dragon-fruit",
        header: "Dragon Fruit",
        imageLink: "dragonFruit",
        flag: "healthy",
      },
      {
        id: 11,
        name: "milk-chocolate",
        header: "Milk Chocolate",
        imageLink: "milkChocolate",
        flag: "unhealthy",
      },
      {
        id: 12,
        name: "fried-fish-sticks",
        header: "Fried Fish Sticks",
        imageLink: "friedFishSticks",
        flag: "unhealthy",
      },
      {
        id: 13,
        name: "apple-caramel",
        header: "Apple Slices with Caramel Sauce",
        imageLink: "appleCaramel",
        flag: "unhealthy",
      },
      {
        id: 14,
        name: "fried-zucchini-fries",
        header: "Fried Zucchini Fries",
        imageLink: "friedZucchiniFries",
        flag: "unhealthy",
      },
      {
        id: 15,
        name: "butter",
        header: "Butter",
        imageLink: "butter",
        flag: "unhealthy",
      },
    ],
  },
];
